import { memo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonActions = ({ className, title, children, testId }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        className={className}
        data-testid="button-actions"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{title}</span>
        <FontAwesomeIcon
          icon={isOpen ? 'chevron-up' : 'chevron-down'}
          className="ml-2 text-brand-primary inline-block"
          size="xs"
        />
      </button>
      {isOpen && (
        <div
          className="card w-48 absolute right-0"
          data-testid="button-actions-dropdown"
        >
          {children}
        </div>
      )}
    </div>
  );
};

ButtonActions.defaultProps = {
  className: 'btn btn-secondary h-11 px-12',
};

export default memo(ButtonActions);
